module.exports = __webpack_public_path__ + "static/media/location-copy-4.6a567651.svg";